(function () {
  const loadedStyles = new Set();
  const loadedScripts = new Map();
  const groupLoads = new Map();
  const config = window.ArtTheoryDeferredAssets || {};

  function loadStyle(href) {
    if (!href || loadedStyles.has(href) || document.querySelector(`link[href="${href}"]`)) return Promise.resolve();

    loadedStyles.add(href);

    return new Promise((resolve) => {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = href;
      link.onload = resolve;
      link.onerror = resolve;
      document.head.appendChild(link);
    });
  }

  function loadScript(src) {
    if (!src || document.querySelector(`script[src="${src}"]`)) return Promise.resolve();
    if (loadedScripts.has(src)) return loadedScripts.get(src);

    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = src;
      script.defer = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    }).catch((error) => {
      console.error(error);
    });

    loadedScripts.set(src, promise);
    return promise;
  }

  // One load per group. A second caller (pointerover, then the tap) must wait for the same chain: the
  // tag-exists checks above resolve as soon as a tag is in the DOM, before its file has loaded.
  function loadGroup(group) {
    if (groupLoads.has(group)) return groupLoads.get(group);

    const assets = config[group] || {};
    const styleLoads = (assets.styles || []).map(loadStyle);
    const promise = Promise.all(styleLoads).then(() =>
      (assets.scripts || []).reduce((chain, src) => chain.then(() => loadScript(src)), Promise.resolve())
    );

    groupLoads.set(group, promise);
    return promise;
  }

  function openCartDrawer(trigger) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && customElements.get('cart-drawer')) {
      drawer.open(trigger);
    } else if (trigger && trigger.href) {
      // The drawer script failed to load: fall back to the cart page instead of a dead tap.
      window.location.href = trigger.href;
    }
  }

  function bindCartIntent() {
    const cartLink = document.querySelector('#cart-icon-bubble');

    document.addEventListener(
      'submit',
      (event) => {
        if (customElements.get('product-form') || !event.target.closest('product-form')) return;

        event.preventDefault();
        event.stopImmediatePropagation();
        loadCartAssets().then(() => event.target.requestSubmit(event.submitter || undefined));
      },
      true
    );

    document.addEventListener(
      'pointerover',
      (event) => {
        if (event.target.closest('#cart-icon-bubble, product-form, .quick-add__submit')) loadCartAssets();
      },
      { passive: true }
    );

    document.addEventListener(
      'focusin',
      (event) => {
        if (event.target.closest('#cart-icon-bubble, product-form, .quick-add__submit')) loadCartAssets();
      },
      true
    );

    if (!cartLink) return;

    cartLink.addEventListener(
      'click',
      (event) => {
        const drawer = document.querySelector('cart-drawer');
        if (!drawer || customElements.get('cart-drawer')) return;

        event.preventDefault();
        loadCartAssets().then(() => openCartDrawer(cartLink));
      },
      true
    );
  }

  function bindPredictiveSearchIntent() {
    const searchSelector = 'predictive-search input[type="search"], .header__search summary';

    function warmSearch(event) {
      if (!event.target.closest(searchSelector)) return;

      loadPredictiveSearchAssets().then(() => {
        const input = event.target.closest('predictive-search')?.querySelector('input[type="search"]');
        if (input && input.value) input.dispatchEvent(new Event('input', { bubbles: true }));
      });
    }

    document.addEventListener('pointerover', warmSearch, { passive: true });
    document.addEventListener('focusin', warmSearch, true);
    document.addEventListener('click', warmSearch, true);
  }

  function loadCartAssets() {
    window.ArtTheoryDeferredAssets.cartLoaded = true;
    return loadGroup('cart');
  }

  function loadPredictiveSearchAssets() {
    window.ArtTheoryDeferredAssets.predictiveSearchLoaded = true;
    return loadGroup('predictiveSearch');
  }

  window.ArtTheoryDeferredAssets.loadCart = loadCartAssets;
  window.ArtTheoryDeferredAssets.loadPredictiveSearch = loadPredictiveSearchAssets;

  if (config.cart?.immediate) loadCartAssets();
  if (config.predictiveSearch?.immediate) loadPredictiveSearchAssets();

  bindCartIntent();
  bindPredictiveSearchIntent();
})();
